import { Box, Checkbox, FormControlLabel, MenuItem, Radio, RadioGroup, Stack, TextField, Typography } from "@mui/material";
import { fedVerseTypes } from "../asset/variables";
import moment from "moment";

export default function Step1(props) {
    return(
        <Stack direction='column' spacing={3}>
            <Box>
                <Typography variant="subtitle1">Versement FEAM</Typography>
                <RadioGroup row sx={{minWidth:'500px'}} defaultValue="siège" value={props.fedVerseType} onChange={(event)=> props.setFedVerseType(event.target.value)}>
                    {fedVerseTypes.map(versetype=>(versetype.value==='virement'?props.eglise.have_banque:true)&&<FormControlLabel key={versetype.value} value={versetype.value} control={<Radio/>} label={versetype.label} />)}
                </RadioGroup>
            </Box>
            <Box>
                <Typography variant="subtitle1">Répartition part locale restante</Typography>
                <Stack direction='row' spacing={3} alignItems='center'>
                    <FormControlLabel control={<Checkbox checked={props.localVerseType.includes('petite-caisse')} onChange={()=>props.setLocalVerseType(old=>old.includes('petite-caisse')?old.filter(tp=>tp!=='petite-caisse'):[...old, 'petite-caisse'])}/>} label="Petite-caisse" />
                    {props.eglise?.have_banque&&<FormControlLabel control={<Checkbox checked={props.localVerseType.includes('banque')} onChange={()=>props.setLocalVerseType(old=>old.includes('banque')?old.filter(tp=>tp!=='banque'):[...old, 'banque'])}/>} label="Banque église" />}
                </Stack>
            </Box>
            {!props.isEdit&&<Box>
                <Typography variant="subtitle1">Période</Typography>
                <Stack direction='row' spacing={2} alignItems='center'>
                    <Typography>Verser les dons du</Typography>
                    <TextField select size="small" sx={{width:'20%', minWidth:'120px'}} value={props.dateDons} onChange={e=>props.setDate(e.target.value)}>
                        {props.dispoDates.sort((a,b)=>new Date(a).getTime()-new Date(b).getTime()).map(date=><MenuItem key={date} value={date}>{moment.utc(date).format('DD/MM/yyyy')}</MenuItem>)}
                    </TextField>
                </Stack>
            </Box>}
        </Stack>
    )
}